import { useMemo } from "react";
import { normalize } from "../../../../utils/helpers/normalize";
import { useCompanyPreferences } from "./usePreferences";
import { useFiltersConfig } from "./useFiltersConfig";

const generateFilters = (field: string) => {
    return [{ name: field, method: "", value: undefined }];
};

export const useConfigInitialFilters = (feature: string, defaultFilterField: string) => {
    const configFilters = useFiltersConfig(feature);
    const configDefaultFilter = useCompanyPreferences(`${feature}.defaultFilter`);

    return useMemo(() => {
        if (!configFilters) {
            return generateFilters(configDefaultFilter || defaultFilterField);
        }
        const filtersMap: any = normalize(
            configFilters.filter(({ hide }: any) => !hide),
            "accessor",
        );

        const filter = filtersMap[configDefaultFilter]
            || filtersMap[defaultFilterField]
            || Object.values(filtersMap)[0];

        if (!filter) {
            return [];
        }
        return generateFilters((filter as any).accessor);
    }, [configFilters, configDefaultFilter, defaultFilterField]);
}
